<style scoped>
    .expense-group-print-container{
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 20px;
        font-size: 12px;
        z-index: 10000;
        overflow-y:scroll;
        color: #000;
        background: white;
    }
    .edit-container{
        /* position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 20px;
        overflow: auto;
        background: white;
        z-index: 999; */
    }
    .edit-header{
        font-size: 18px;
        font-weight: bold;
    }
    .close-editor-btn{
        position: absolute;
        top: 20px;
        right: 20px;
    }
    @media print {
        .close-editor-btn{
            display: none;
        }
    }
    .edit-title{
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .edit-title img{
        height: 26px;
        vertical-align: text-top;
    }
    .fill-info{
        padding-bottom: 5px;
        border-bottom: 1px solid #000000;
    }
    .fill-info-bottom{
        padding-top: 20px;
    }
    table{
        border-collapse:collapse;
    }
    table tr{
        border-bottom: 1px solid #000000;
    }
    table th, table td{
        border-right: 1px solid #000000;
    }
    .payee-account-container{
        margin-top: 20px;
    }
    .payee-account-table{
        width: 100%;
        border: 1px solid #000000;
    }
    .payee-account-table td{
        padding: 10px;
        text-align: center;
    }
    .payee-account-col-1{
        width: 60px;
        font-size: 15px;
        font-weight: bold;
    }
    .payee-account-col-2{
        width: 80px;
    }
    .payee-account-handler{
        padding: 10px;
    }
    .chinese-number{
        display: inline-block;
        width: 70px;
        text-align: right;
    }
    .cn-number{
        font-size: 1.1em;
        font-weight: bold;
        font-style: italic;
    }
    .edit-expense-container{
        margin-top: 20px;
    }
    .edit-expense-table{
        border: 1px solid #000000;
        width: 100%;
    }
    .edit-expense-table th{
        padding: 6px;
        text-align: center;
    }
    .edit-expense-table td{
        padding: 6px;
    }
    .edit-expense-col-1{
        width: 60px;
        text-align: center;
    }
    .edit-expense-col-7{
        min-width: 70px;
    }
    .td-price{
        text-align: right;
    }
    .qr-code{
        float: right;
        transform: translateY(-5px);
    }
</style>
<template>
  <div
    v-show="is_show"
    v-dom-portal
    class="expense-group-print-container"
  >
    <div class="close-editor-btn">
      <Button
        type="primary"
        icon="md-print"
        @click="rePrint"
      >
        打印
      </Button>
      <Button
        type="warning"
        icon="md-close"
        @click="close"
      >
        关闭
      </Button>
    </div>
    <template v-for="expense_group in expense_groups">
      <div
        v-show="!loading"
        ref="print"
        :key="expense_group.id"
        class="edit-container"
      >
        <div class="edit-header text-center">
          <span>{{ getCompanyNameById(expense_group.company_id) }}</span>
        </div>
        <div class="edit-title">
          <img src="../../../image/logo.png">
          <span>{{ edit_title }}</span>
        </div>
        <div class="fill-info">
          <Row>
            <i-col span="6">
              <span class="fill-info-title">填制时间:</span>
              <span>{{ getFillTime(expense_group) }}</span>
            </i-col>
            <i-col span="6">
              <span class="fill-info-title">经办人:</span>
              <span>{{ expense_group.apply_user }}</span>
            </i-col>
            <i-col span="6">
              <span class="fill-info-title">填制人:</span>
              <span>{{ expense_group.fill_user }}</span>
            </i-col>
            <i-col span="6">
              <span class="fill-info-title">编号:</span>
              <span>{{ expense_group.uid }}</span>
            </i-col>
          </Row>
        </div>
        <div class="payee-account-container">
          <Row>
            <i-col span="12">
              <table class="payee-account-table">
                <tbody>
                  <tr>
                    <td
                      class="payee-account-col-1"
                      rowspan="4"
                    >
                      <div>收</div>
                      <div>款</div>
                      <div>方</div>
                    </td>
                    <td class="payee-account-col-2">
                      付款币种:
                    </td>
                    <td class="text-left">
                      {{ getCurrencyName(expense_group.currency) }}
                    </td>
                  </tr>
                  <tr>
                    <td>账户名:</td>
                    <td class="text-left">
                      {{ expense_group.payee_account_name }}
                    </td>
                  </tr>
                  <tr>
                    <td>开户行:</td>
                    <td class="text-left">
                      {{ expense_group.payee_bank }}
                    </td>
                  </tr>
                  <tr>
                    <td>账号:</td>
                    <td class="text-left">
                      {{ expense_group.payee_bank_number }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </i-col>
            <i-col span="12">
              <div class="qr-code">
                <qrcode
                  v-if="expense_group.uid"
                  :value="expense_group.uid"
                  :size="150"
                />
              </div>
            </i-col>
          </Row>
        </div>
        <div class="edit-expense-container">
          <table class="edit-expense-table">
            <thead>
              <tr>
                <th class="edit-expense-col-1">
                  序号
                </th>
                <th class="edit-expense-col-3">
                  项目描述
                </th>
                <th class="edit-expense-col-6">
                  付款金额
                </th>
                <th class="edit-expense-col-7">
                  费用类别
                </th>
                <th class="edit-expense-col-8">
                  备注
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(expense, index) in expense_group.expenses"
                :key="index"
              >
                <td class="text-center">
                  {{ index+1 }}
                </td>
                <td>
                  <span>{{ expense.name }}</span>
                </td>
                <td class="td-price">
                  <span>{{ $util.formatPrice(expense.price) }}</span>
                </td>
                <td>
                  <div>{{ getExpenseTypeName(expense.expense_type_id) }}</div>
                </td>
                <td>
                  <span>{{ expense.desc }}</span>
                </td>
              </tr>
              <tr>
                <td class="text-center">
                  合计
                </td>
                <td class="text-center">
                  -
                </td>
                <td class="td-price">
                  <span>{{ $util.formatPrice(getTotalPrice(expense_group)) }}</span>
                </td>
                <td class="text-center">
                  -
                </td>
                <td class="text-center">
                  -
                </td>
              </tr>
              <tr v-if="expense_group.advance.id">
                <td class="text-center">
                  预支单
                </td>
                <td
                  colspan="2"
                  class="text-center"
                >
                  {{ expense_group.advance.uid }}
                </td>
                <td
                  colspan="2"
                  class="text-center"
                >
                  {{ expense_group.advance.name }}
                </td>
                <td
                  colspan="2"
                  class="text-center"
                >
                  预支时间: {{ expense_group.advance.paid_at }}
                </td>
              </tr>
              <tr v-if="expense_group.advance.id">
                <td
                  colspan="2"
                  class="text-center"
                >
                  报销金额: {{ $util.formatPrice(getTotalPrice(expense_group)) }}
                </td>
                <td
                  colspan="2"
                  class="text-center"
                >
                  预支金额: {{ $util.formatPrice(expense_group.advance.total_price) }}
                </td>
                <td class="text-center">
                  <p>实际应付金额</p>
                  <p>(负数为退回金额)</p>
                </td>
                <td
                  colspan="2"
                  class="text-center"
                >
                  {{ $util.formatPrice(getTotalPrice(expense_group)) }}
                </td>
              </tr>
              <tr>
                <td colspan="6">
                  大写金额
                  <span v-if="isReturnMoney(expense_group)">(退回)</span>:
                  <span class="chinese-number">
                    <span :class="{'cn-number': isANumber(expense_group, 100000000)}">
                      {{ getChineseNumOfDigit(expense_group, 100000000) }}
                    </span>
                    <span>亿</span>
                  </span>
                  <span class="chinese-number">
                    <span :class="{'cn-number': isANumber(expense_group, 10000000)}">
                      {{ getChineseNumOfDigit(expense_group, 10000000) }}
                    </span>
                    <span>仟</span>
                  </span>
                  <span class="chinese-number">
                    <span :class="{'cn-number': isANumber(expense_group, 1000000)}">
                      {{ getChineseNumOfDigit(expense_group, 1000000) }}
                    </span>
                    <span>佰</span>
                  </span>
                  <span class="chinese-number">
                    <span :class="{'cn-number': isANumber(expense_group, 100000)}">
                      {{ getChineseNumOfDigit(expense_group, 100000) }}
                    </span>
                    <span>拾</span>
                  </span>
                  <span class="chinese-number">
                    <span :class="{'cn-number': isANumber(expense_group, 10000)}">
                      {{ getChineseNumOfDigit(expense_group, 10000) }}
                    </span>
                    <span>万</span>
                  </span>
                  <span class="chinese-number">
                    <span :class="{'cn-number': isANumber(expense_group, 1000)}">
                      {{ getChineseNumOfDigit(expense_group, 1000) }}
                    </span>
                    <span>仟</span>
                  </span>
                  <span class="chinese-number">
                    <span :class="{'cn-number': isANumber(expense_group, 100)}">
                      {{ getChineseNumOfDigit(expense_group, 100) }}
                    </span>
                    <span>佰</span>
                  </span>
                  <span class="chinese-number">
                    <span :class="{'cn-number': isANumber(expense_group, 10)}">
                      {{ getChineseNumOfDigit(expense_group, 10) }}
                    </span>
                    <span>拾</span>
                  </span>
                  <span class="chinese-number">
                    <span :class="{'cn-number': isANumber(expense_group, 1)}">
                      {{ getChineseNumOfDigit(expense_group, 1) }}
                    </span>
                    <span>元</span>
                  </span>
                  <span class="chinese-number">
                    <span :class="{'cn-number': isANumber(expense_group, 0.1)}">
                      {{ getChineseNumOfDigit(expense_group, 0.1) }}
                    </span>
                    <span>角</span>
                  </span>
                  <span class="chinese-number">
                    <span :class="{'cn-number': isANumber(expense_group, 0.01)}">
                      {{ getChineseNumOfDigit(expense_group, 0.01) }}
                    </span>
                    <span>分</span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-if="expense_group.contract_id"
          class="line"
        >
          关联合同: {{ expense_group.contract.uid }}, 合同名称: {{ expense_group.contract.name }},
          申请人: {{ expense_group.contract.apply_user }},
          对方公司: {{ expense_group.contract.payee_company }},
          合同总价: ￥{{ formatPrice(expense_group.contract.total_price) }}
        </div>
        <div class="fill-info-bottom">
          <Row>
            <i-col span="6">
              <span class="fill-info-title">经办:</span>
            </i-col>
            <i-col span="6">
              <span class="fill-info-title">负责人审批:</span>
            </i-col>
            <i-col span="6">
              <span class="fill-info-title">财务审核:</span>
            </i-col>
            <i-col span="6">
              <span class="fill-info-title">出纳:</span>
            </i-col>
          </Row>
        </div>
      </div>
      <Spin
        v-if="loading"
        :key="expense_group.id + ' spin'"
        fix
      />
      <div
        :key="expense_group.id + ' div'"
        style="border-bottom: 1px solid #666; margin-bottom: 10px; page-break-after: always;"
      />
    </template>
  </div>
</template>
<script :route="{path: '/fin/expense_group_print',noChkout: true}">
  import ExpenseUtil from '../../../libs/expense_util';
  import ExpenseGroupUtil from '../../expense_group/libs/util';
  import {mapGetters} from "vuex";
  export default {
    props: ['type'],
    data() {
      return {
        loading: false,
        is_show: false,
        // expense_group: {company_id: 0, expenses: [], advance: {}, currency: 'CNY'},
        expense_groups: [{company_id: 0, expenses: [], advance: {}, currency: 'CNY'}]
      }
    },
    computed: {
      ...mapGetters({
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
        expense_types_hash: 'async/expense_types_hash',
      }),
      edit_title() {
        return `${ExpenseUtil.getPaymentType(this.type)}申请单`;
      },
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      print_expense_groups(expense_groups) {
        // this.$set(this, 'expense_group', data.expense_group)
        window.eventHub.$emit('hideApp')
        this.is_show = true
        this.loading = true
        ExpenseGroupUtil.getDetails(expense_groups.map(expense_group => expense_group.id)).then((data) => {
          // this.$set(this, 'expense_group', data.expense_group);
          this.expense_groups = data.expense_groups
          setTimeout(() => {
            window.print()
          }, 100)
        }).catch((e) => {
          this.$Message.error('获取数据失败，请重试!')
        }).finally(() => {
          this.loading = false
        })
      },
      print(expense_group) {
        window.eventHub.$emit('hideApp')
        this.is_show = true
        this.loading = true
        ExpenseGroupUtil.getDetail(expense_group.id).then((data) => {
          // this.$set(this, 'expense_group', data.expense_group)
          this.expense_groups = [data.expense_group]
          setTimeout(() => {
            window.print()
          }, 100);
        }).catch((e) => {
          this.$Message.error('获取数据失败, 请重试!');
        }).finally(() => {
          this.loading = false;
        });
      },
      rePrint() {
        window.print();
      },
      close() {
        window.eventHub.$emit('showApp')
        this.is_show = false;
        //this.$router.go(-1);
      },
      getCompanyNameById(id) {
        const company = this.companies_hash[id];
        return company ? company.name : '';
      },
      getTeamNameById(id) {
        const team = this.teams_hash[id];
        return team ? team.name : '';
      },
      getFillTime(expense_group) {
        const time = expense_group.created_at || new Date();
        return moment(time).format('YYYY-MM-DD');
      },
      getTotalInvoicePrice(expense_group) {
        let total = 0;
        expense_group.expenses.forEach((expense) => {
          const invoice_price = expense.invoice_price || 0;
          total = math.eval(total + '+' + invoice_price);
        });
        return total.toFixed(2);
      },
      getTotalPrice(expense_group) {
        let total = 0;
        expense_group.expenses.forEach((expense) => {
          const price = expense.price || 0;
          total = math.eval(total + '+' + price);
        });
        return total.toFixed(2);
      },
      getRealPrice(expense_group) {
        const total = this.getTotalPrice(expense_group);
        const advance_price = expense_group.advance.total_price;
        if (advance_price) {
          return math.eval(total + '-' + advance_price).toFixed(2);
        } else {
          return total;
        }
      },
      getCurrencyName(currency_value) {
        return ExpenseUtil.getCurrencyName(currency_value);
      },
      getCurrencyLabel(currency_value) {
        return ExpenseUtil.getCurrencyLabel(currency_value);
      },
      getCurrencySymbol(currency_value) {
        return ExpenseUtil.getCurrencySymbol(currency_value);
      },
      getDisplayTotalPrice() {
        //
      },
      formatPrice(price) {
        price = price ? price : 0;
        return math.eval(price).toFixed(2);
      },
      getChineseNumOfDigit(expense_group, digit) {
        const total = math.abs(this.getRealPrice(expense_group));
        if (math.eval(total + '< ' + digit)) {
          return 'X';
        }
        const num = math.eval(total + '/' + digit + '%' + '10').floor().toString();
        return this.$util.getChineseNum(num);
      },
      isANumber(expense_group, digit) {
        const total = math.abs(this.getRealPrice(expense_group));
        return math.eval(total + '>' + digit)
      },
      isReturnMoney(expense_group) {
        const total = this.getRealPrice(expense_group);
        return math.eval(total + '< 0');
      },
      getExpenseTypeName(id) {
        return id ? this.expense_types_hash[id].full_name : '';
      },
    }
  }
</script>
